<section class="about" >
  <div class="about__filter"></div>
  <div class="about__content" [ngClass]="{'slide-left': slideLeft}">
    <div class="about__content__row about__content__row_left">
    <p class="about__content__row__amvara__goal">
      <span class="bold upper">{{ 'about.goalAmvara' | transloco }}</span> {{ 'about.goal' | transloco }}
    </p>
    <div class="about__content__row__container__mobile">
      <div class="about__content__row__divText__mobile">
        <p class="about__content__row__text__mobile">
          {{ 'about.text' | transloco }}
        </p>
      </div>
    </div>
    <hr class="about__content__row__separator">
    @if (!mobileOrDesktop) {
      <div class="about__content__row__left__desktop">
        <img class="about__content__row__circle" src="assets/img/amvara_web_circle_binary.svg" [attr.alt]="'alts.binaryCodeCircle' | transloco" fetchpriority="high" loading="eager" decoding="async">
        <a [routerLink]="language.link(['about-night'])" class="about__content__row__button__with__icon"><p>{{ 'about.whatIsCode' | transloco }}</p><img src="assets/img/amvara_web_icon_sun.svg" [attr.alt]="'alts.sunIconDayMode' | transloco" /></a>
        <a [routerLink]="language.link(['amvara-clock'])" class="about__content__row__button__with__icon"><p>{{ 'about.amvarasClock' | transloco }}</p><img src="assets/img/amvara_web_icon_clock.svg" [attr.alt]="'alts.clockIconAmvarasClock' | transloco" /></a>
        <a (click)="rotateImage()"
        (click)="openDialog($event)" 
        class="about__content__row__button__with__icon__play"
        href="#">
            <p>{{ 'about.amvarasVideos' | transloco }}</p>
            <img src="assets/img/amvara_web_icon_play.svg" 
                [attr.alt]="'alts.play' | transloco"
                [style.transform]="'rotate(' + rotationAngle + 'deg)'" />
        </a>
      </div>
    }
    @if (mobileOrDesktop) {
      <div         class="about__content__row__left__mobile">
        <img src="assets/img/amvara_web_icon_(more).svg" [attr.alt]="'alts.moreInformationIcon' | transloco" class="about__content__row__more">
        <a [routerLink]="language.link(['how-we-can-help-you'])" class="about__content__row__button __long"><p>{{ 'about.howCanWeHelpYou' | transloco }}</p></a>
        <a [routerLink]="language.link(['what-do-we-do'])" class="about__content__row__button __short"><p>{{ 'about.whatDoWeDo' | transloco }}</p></a>
        <a [routerLink]="language.link(['who-do-we-work-for'])" class="about__content__row__button __long"><p>{{ 'about.whoDoWeWorkFor' | transloco }}</p></a>
        <a [routerLink]="language.link(['who-we-are', 1])" class="about__content__row__button __short"><p>{{ 'about.whoWeAre' | transloco }}</p></a>
      </div>
    }
  </div>
  <hr class="about__content__separator">
  <div class="about__content__row about__content__row_right">
    <div class="about__content__row__container">
      <div class="about__content__row__divText">
        <p class="about__content__row__text">
          {{ 'about.text' | transloco }}
        </p>
      </div>
    </div>
    @if (!mobileOrDesktop) {
      <div class="about__content__row__right__desktop">
        <img src="assets/img/amvara_web_icon_(more).svg" [attr.alt]="'alts.moreInformation' | transloco" class="about__content__row__more">
        <a [routerLink]="language.link(['how-we-can-help-you'])" class="about__content__row__button __long"><p>{{ 'about.howCanWeHelpYou' | transloco }}</p></a>
        <a [routerLink]="language.link(['what-do-we-do'])" class="about__content__row__button __short"><p>{{ 'about.whatDoWeDo' | transloco }}</p></a>
        <a [routerLink]="language.link(['who-do-we-work-for'])" class="about__content__row__button __long"><p>{{ 'about.whoDoWeWorkFor' | transloco }}</p></a>
        <a [routerLink]="language.link(['who-we-are', 1])" class="about__content__row__button __short"><p>{{ 'about.whoWeAre' | transloco }}</p></a>
      </div>
    }
    @if (mobileOrDesktop) {
      <div class="about__content__row__right__mobile">
        <img class="about__content__row__circle" src="assets/img/amvara_web_circle_binary.svg" [attr.alt]="'alts.numbers' | transloco" fetchpriority="high" loading="eager" decoding="async">
        <a [routerLink]="language.link(['about-night'])" class="about__content__row__button__with__icon"><p>{{ 'about.whatIsCode' | transloco }}</p><img src="assets/img/amvara_web_icon_sun.svg" [attr.alt]="'alts.sunIconDayMode' | transloco" /></a>
        <a [routerLink]="language.link(['amvara-clock'])" class="about__content__row__button__with__icon"><p>{{ 'about.amvarasClock' | transloco }}</p><img src="assets/img/amvara_web_icon_clock.svg" [attr.alt]="'alts.clockIconAmvarasClock' | transloco" /></a>
        <a (click)="openDialog($event)" class="about__content__row__button__with__icon__play">
          <p>{{ 'about.amvarasVideos' | transloco }}</p>
          <img src="assets/img/amvara_web_icon_play.svg" 
              [attr.alt]="'alts.play' | transloco"
              [style.transform]="'rotate(' + rotationAngle + 'deg)'" 
          />
      </a>
      </div>
    }
  </div>
</div>
<mat-accordion>
  <mat-expansion-panel (opened)="onPanelOpened()" [expanded]="amvaraVideosClick">
    <div class="dialog-container show">
      <app-amvara-video [id]="'goToPos'"></app-amvara-video>
    </div>
  </mat-expansion-panel>
</mat-accordion>
</section>
